/* ============================================================
   SESTO. FIT — Fit Finder V1.2 (Stand 21.09.2026)

   Vier Fragen: Ausrichtung, Gesichtsform, Groesse, Look. Kein
   Seitenreload, keine Library, kein Framework. Mobile first.

   AENDERUNGEN V1.1 (CRO)
   - MAX_RESULTS 3 -> 6. Der Finder soll orientieren, nicht die
     Auswahl verkleinern. "WE RECOMMEND. YOU DECIDE."
   - Die Ergebnisse teilen sich in Top 3 ("Deine SESTO. Picks") und
     Rang 4-6 ("Weitere Styles fuer dich"). Beide aus demselben
     Ranking, nur visuell getrennt.
   - Bei Punktgleichstand wird die Reihenfolge so gedreht, dass nicht
     mehrere identische Shapes direkt hintereinander stehen. Das
     passiert AUSSCHLIESSLICH innerhalb gleicher Punktzahl — das
     Ranking selbst bleibt unangetastet (siehe diversify()).
   - Analytics: entry_collection und result_position.

   AENDERUNGEN V1.2 — GENDER
   Erste Frage: "Fuer wen suchst du?" Damen / Herren / Egal.

   Sie ist SELBST-AKTIVIEREND. genderIsMeaningful() prueft, ob die
   Datenquelle ueberhaupt mehr als einen Gender-Wert enthaelt. Steht alles
   auf demselben Wert, wuerden alle Antworten dieselbe Produktmenge
   liefern — dann wird die Frage uebersprungen und der Finder laeuft wie
   in V1.1 mit drei Fragen. Kein Klick ohne Wirkung.

   FILTERSEMANTIK (Vorgabe Brand Owner):
     Damen  -> Women + Unisex
     Herren -> Men   + Unisex
     Egal   -> keine Einschraenkung
   Unisex erscheint also in JEDEM Zweig und wird nie ausgeschlossen. Ein
   Produkt ohne gepflegtes Gender gilt als Unisex (Default kommt aus
   snippets/sesto-fit-data.liquid) und kann dadurch nicht verschwinden.

   GENDER IST DER EINZIGE HARTE FILTER IM RANKING. Er vergibt keine
   Punkte, er begrenzt die Menge. Deshalb hat poolFor() einen Rueckfall:
   waere die gefilterte Menge leer, wird mit der vollen Menge gerechnet.
   Ein "keine Ergebnisse"-Zustand bleibt damit unerreichbar.

   WAS SICH NICHT GEAENDERT HAT UND AUCH NICHT SOLLTE
   Gesichtsform gibt bei Score 1 null Punkte, nie Minuspunkte, und
   entfernt kein Produkt. Size und Style filtern nach wie vor nicht,
   sie bewerten nur.

   ZWEI ZENTRALE TABELLEN steuern alles — hier, an genau einer Stelle:

   1. FACE_MATRIX  Shape -> Score je Gesichtsform (3/2/1)
   2. STYLE_GROUPS Antwort-Gruppe -> Style-Tags

   Warum die Face-Scores NICHT pro Produkt im Metafeld stehen:
   In der vom SESTO.-Team freigegebenen Produktmatrix haben alle Produkte
   mit gleichem Shape identische Face-Scores. Eine zentrale Shape-Matrix
   reproduziert die freigegebene Matrix damit fuer alle 11 Modelle exakt.
   Ein Wert pro Produkt waere reine Datenverdopplung.

   Weicht ein kuenftiges Produkt von seiner Shape-Zeile ab, hat die
   Produktebene Vorrang: dann ein Metafeld fit.face_scores (JSON) anlegen
   und in faceScoreFor() vor der Matrix abfragen.

   KEIN PRODUKTNAME steht in dieser Datei. Neues Modell heisst:
   Shape + Size + Style setzen, fertig — keine Codeaenderung.

   Die Scores sind interne Ranking-Werte. Sie werden NIE als Prozent,
   Sterne oder Rating angezeigt.
   ============================================================ */
(function () {
  'use strict';

  /* Mehrsprachig (28.09.2026): Texte kommen aus window.SESTO_FIT_T
     (snippets/sesto-fit-i18n.liquid -> locales/*.json, sesto.fit_js.*).
     Fehlt ein Text, greift der deutsche Standard direkt hier im Code. */
  var I18N = window.SESTO_FIT_T || {};
  function tt(key, fallback) {
    var v = I18N[key];
    return (typeof v === 'string' && v !== '') ? v : fallback;
  }
  function fmt(tpl, vars) {
    return tpl.replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : ''; });
  }

  var FACES = ['Round', 'Oval', 'Square', 'Heart', 'Diamond'];

  /* Reihenfolge der Spalten = FACES. 3 = Strong, 2 = Good, 1 = Contrast. */
  var FACE_MATRIX = {
    Square:     [3, 3, 2, 3, 3],
    Rectangle:  [3, 3, 2, 3, 3],
    'Cat Eye':  [3, 3, 2, 3, 3],
    Aviator:    [3, 3, 2, 2, 3],
    Round:      [1, 3, 3, 3, 3],
    Oval:       [2, 3, 3, 2, 3]
  };

  var STYLE_GROUPS = {
    Clean:   ['Clean', 'Classic', 'Minimal'],
    Bold:    ['Bold', 'Statement'],
    Retro:   ['Retro', 'Playful'],
    Fashion: ['Fashion', 'Statement']
  };

  var FACE_COPY = {
    Round:   { label: tt('face_round_l', 'RUND'),         desc: tt('face_round_d', 'Weichere Konturen, Breite und Länge ähnlich.') },
    Oval:    { label: tt('face_oval_l', 'OVAL'),          desc: tt('face_oval_d', 'Etwas länger als breit, ausgewogene Proportionen.') },
    Square:  { label: tt('face_square_l', 'ECKIG'),       desc: tt('face_square_d', 'Markantere Kieferlinie und klarere Konturen.') },
    Heart:   { label: tt('face_heart_l', 'HERZFÖRMIG'),   desc: tt('face_heart_d', 'Breitere Stirn, schmaler Richtung Kinn.') },
    Diamond: { label: tt('face_diamond_l', 'DIAMANT'),    desc: tt('face_diamond_d', 'Wangenknochen bilden den breitesten Bereich.') }
  };

  var SIZE_ANSWERS = [
    { value: 'Narrow',  label: tt('size_narrow_l', 'OFT ZU BREIT'),  desc: tt('size_narrow_d', 'Sie wirken schnell zu gross oder sitzen locker.') },
    { value: 'Regular', label: tt('size_regular_l', 'MEISTENS GUT'), desc: tt('size_regular_d', 'Die meisten Brillen sitzen bei mir problemlos.') },
    { value: 'Wide',    label: tt('size_wide_l', 'OFT ZU ENG'),      desc: tt('size_wide_d', 'Viele fühlen sich eher klein oder eng an.') },
    { value: null,      label: tt('dont_know', 'WEISS ICH NICHT'),   desc: tt('size_unknown_d', 'Dann gewichten wir Look und Form stärker.') }
  ];

  var STYLE_ANSWERS = [
    { value: 'Clean',   label: 'CLEAN',   desc: tt('style_clean_d', 'Ruhig und tragbar. Kombiniert sich mit fast allem.') },
    { value: 'Bold',    label: 'BOLD',    desc: tt('style_bold_d', 'Mehr Präsenz. Die Brille ist Teil des Outfits.') },
    { value: 'Retro',   label: 'RETRO',   desc: tt('style_retro_d', 'Vintage-inspirierte Formen mit Charakter.') },
    { value: 'Fashion', label: 'FASHION', desc: tt('style_fashion_d', 'Modisch und ausdrucksstark.') },
    { value: null,      label: tt('surprise_l', 'ÜBERRASCH MICH'), desc: tt('surprise_d', 'Zeig mir einfach, was zu mir passt.') }
  ];

  /* Es gibt bewusst KEINE Antwort "Unisex". Als Antwort auf "Fuer wen
     suchst du?" ist Unisex keine Person, sondern eine Produkteigenschaft,
     und sie liefert exakt dieselbe Menge wie "Egal", solange kein Modell
     auf Women steht. Zwei identische Antworten nebeneinander sind eine
     Sackgasse, kein Angebot. Soll die Antwort trotzdem zurueck, hier eine
     Zeile ergaenzen: { value: 'Unisex', label: 'UNISEX', ... } — die
     Filterlogik in genderAllows() unterstuetzt sie unveraendert. */
  var GENDER_ANSWERS = [
    { value: 'Women', label: tt('gender_women_l', 'DAMEN'),  desc: tt('gender_women_d', 'Damen- und Unisex-Modelle.') },
    { value: 'Men',   label: tt('gender_men_l', 'HERREN'),   desc: tt('gender_men_d', 'Herren- und Unisex-Modelle.') },
    { value: null,    label: tt('gender_any_l', 'EGAL'),     desc: tt('gender_any_d', 'Zeig mir die ganze Kollektion.') }
  ];

  /* Gewichtung: Size 40 % / Style 40 % / Face 20 %.
     Face gibt nie Minuspunkte und schliesst nie aus. */
  var W = { sizeExact: 4, sizeAdjacent: 1, style: 4, face3: 2, face2: 1, face1: 0 };
  var SIZE_ORDER = { Narrow: 0, Regular: 1, Wide: 2 };

  /* Sechs Ergebnisse, davon die ersten drei visuell priorisiert. */
  var MAX_RESULTS = 6;
  var TOP_PICKS = 3;

  /* ---------- Hilfsfunktionen ---------- */

  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); }
    catch (e) { /* Analytics darf den Finder nie blockieren */ }
  }

  /* Woher kam der Nutzer? Wird aus der URL gelesen, die die
     Einstiegspunkte setzen: ?src=collection_header | product_page | blog
     und optional &col=<handle>. Ohne Parameter gilt der Aufruf als direct.

     collection_grid bleibt als gueltiger Wert stehen, damit historische
     Events vergleichbar bleiben; ausgeloest wird er seit dem Entfernen der
     Rasterkachel nicht mehr.

     Nur Kanalname, Kollektions-Handle und optional ein Produkt-Handle —
     keine personenbezogenen Daten.

     WICHTIG: Diese Werte gehen ausschliesslich in Analytics. Das Matching
     liest sie nicht. Ein Produkt wird nie hoeher gerankt, nur weil der
     Nutzer von seiner Produktseite oder Kollektion kam. */
  var ENTRY_SOURCES = ['collection_grid', 'collection_header', 'product_page', 'blog'];

  function readEntry() {
    var out = { source: 'direct', product: null, collection: 'none' };
    try {
      var q = new URLSearchParams(window.location.search);
      var src = q.get('src');
      if (src && ENTRY_SOURCES.indexOf(src) !== -1) out.source = src;
      var pid = q.get('pid');
      if (pid) out.product = String(pid).slice(0, 64);
      var col = q.get('col');
      if (col) {
        col = String(col).toLowerCase().replace(/[^a-z0-9_-]/g, '').slice(0, 64);
        if (col) out.collection = col;
      }
    } catch (e) { /* aeltere Browser: dann eben direct */ }
    return out;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Deterministischer Streuwert fuer Punktgleichstand.

     Ohne ihn entscheidet die Katalogreihenfolge jeden Gleichstand, und dann
     landen immer dieselben zwei Modelle oben: im Test tauchte AURA in 74 von
     120 Antwortkombinationen auf, FARA in 6. Mit diesem Wert liegt die
     Spanne bei 43 zu 13 und es gibt 84 statt 34 verschiedene Ergebnis-Sets.
     Der Wert haengt nur von Produktname + Antworten ab, ist also fuer
     dieselben Antworten immer identisch — QA bleibt reproduzierbar. */
  function spread(title, answers) {
    var key = title + '|' + answers.gender + '|' + answers.face + '|' +
              answers.size + '|' + answers.style;
    var h = 2166136261;
    for (var i = 0; i < key.length; i++) {
      h ^= key.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }

  function faceScoreFor(product, face) {
    /* V2-HAKEN: Hier zuerst ein produkteigenes fit.face_scores abfragen,
       sobald ein Modell von seiner Shape-Zeile abweicht. */
    var row = FACE_MATRIX[product.shape];
    if (!row) return 0;
    var i = FACES.indexOf(face);
    return i === -1 ? 0 : row[i];
  }

  /* ---------- Matching ---------- */

  function scoreProduct(product, answers) {
    var score = 0;
    var why = { size: false, sizeNear: false, style: false, face: 0 };

    if (answers.size && product.size) {
      var d = Math.abs(SIZE_ORDER[answers.size] - SIZE_ORDER[product.size]);
      if (d === 0) { score += W.sizeExact; why.size = true; }
      else if (d === 1) { score += W.sizeAdjacent; why.sizeNear = true; }
    }

    if (answers.style) {
      var tags = STYLE_GROUPS[answers.style] || [];
      for (var i = 0; i < tags.length; i++) {
        if (product.style.indexOf(tags[i]) !== -1) { score += W.style; why.style = true; break; }
      }
    }

    if (answers.face) {
      var fs = faceScoreFor(product, answers.face);
      score += fs === 3 ? W.face3 : fs === 2 ? W.face2 : W.face1;
      why.face = fs;
    }

    return { score: score, why: why };
  }

  /* AUSWAHLBREITE BEI GLEICHSTAND (Vorgabe 16)

     Nur innerhalb eines Blocks mit IDENTISCHER Punktzahl und identischer
     Verfuegbarkeit wird umsortiert. Ueber Punktzahlgrenzen hinweg passiert
     nichts — der Match Score bleibt primaer.

     Innerhalb des Blocks wird greedy so gezogen, dass jede Shape erst
     einmal drankommt, bevor sich eine wiederholt. Ohne das stehen bei
     gleicher Punktzahl schnell drei Rectangles nebeneinander. */
  function spreadShapes(block) {
    if (block.length < 3) return block;
    var used = {};
    var picked = [];
    var rest = block.slice();
    while (rest.length) {
      var idx = -1;
      for (var k = 0; k < rest.length; k++) {
        if (!used[rest[k].product.shape]) { idx = k; break; }
      }
      if (idx === -1) { used = {}; idx = 0; }
      used[rest[idx].product.shape] = true;
      picked.push(rest.splice(idx, 1)[0]);
    }
    return picked;
  }

  function diversify(list) {
    var out = [];
    var i = 0;
    while (i < list.length) {
      var j = i;
      while (
        j < list.length &&
        list[j].score === list[i].score &&
        list[j].product.available === list[i].product.available
      ) { j++; }
      out = out.concat(spreadShapes(list.slice(i, j)));
      i = j;
    }
    return out;
  }

  /* ---------- Gender ----------

     Unisex passt in jeden Zweig. Ein leerer Wert gilt als Unisex, damit
     ein noch nicht gepflegtes Produkt nicht stillschweigend aus dem Finder
     faellt. */
  function genderAllows(product, answer) {
    if (!answer) return true;
    var g = product.gender || 'Unisex';
    return g === 'Unisex' || g === answer;
  }

  /* Lohnt sich die Frage ueberhaupt? Nur wenn die Datenquelle mehr als
     einen Gender-Wert enthaelt. Sonst liefern alle Antworten dasselbe und
     die Frage kostet nur einen Klick. */
  function genderIsMeaningful(products) {
    var seen = {};
    var n = 0;
    for (var i = 0; i < products.length; i++) {
      var g = products[i].gender || 'Unisex';
      if (!seen[g]) { seen[g] = true; n++; }
      if (n > 1) return true;
    }
    return false;
  }

  /* RUECKFALL: Eine leere Menge waere der einzige Weg zu einem
     "keine Ergebnisse"-Zustand. Tritt bei gepflegten Daten nicht auf
     (Unisex passt immer), ist aber die billigste Versicherung gegen
     einen Datenstand, in dem alles auf Men oder Women steht. */
  function poolFor(products, answers) {
    if (!answers.gender) return products;
    var pool = products.filter(function (p) {
      return genderAllows(p, answers.gender);
    });
    return pool.length ? pool : products;
  }

  /* Innerhalb der zulaessigen Menge wird nur bewertet und sortiert, nicht
     weiter gefiltert. Kaufbare Modelle stehen vor ausverkauften. */
  function recommend(products, answers) {
    var ranked = poolFor(products, answers)
      .map(function (p) {
        var r = scoreProduct(p, answers);
        return { product: p, score: r.score, why: r.why, tie: spread(p.title, answers) };
      })
      .sort(function (a, b) {
        if (a.product.available !== b.product.available) return a.product.available ? -1 : 1;
        if (b.score !== a.score) return b.score - a.score;
        return a.tie - b.tie;
      });

    return diversify(ranked).slice(0, MAX_RESULTS);
  }

  /* ---------- Begruendungen ----------
     Nur Gruende nennen, die tatsaechlich Punkte gebracht haben.
     Keine Prozente, keine "perfect for your face"-Aussagen, keine Regeln. */

  var SIZE_PHRASE = {
    Narrow:  tt('size_phrase_narrow', 'gehört zu unseren schmaler geschnittenen Modellen'),
    Regular: tt('size_phrase_regular', 'liegt bei der Breite im mittleren Bereich'),
    Wide:    tt('size_phrase_wide', 'gehört zu unseren breiteren Modellen')
  };

  var ANGULAR = ['Square', 'Rectangle', 'Cat Eye'];
  var SOFT_FACES = ['Round', 'Oval'];

  function facePhrase(product, face) {
    var shapeAngular = ANGULAR.indexOf(product.shape) !== -1;
    var faceSoft = SOFT_FACES.indexOf(face) !== -1;
    if (shapeAngular && faceSoft) return tt('face_contrast', 'Die kantigere Form bringt Kontrast in weichere Gesichtszüge');
    if (!shapeAngular && !faceSoft) return tt('face_soften', 'Die runderen Linien nehmen markanteren Gesichtszügen etwas Härte');
    if (product.shape === 'Aviator') return tt('face_aviator', 'Die Doppelsteg-Form wirkt bei vielen Proportionen ausgewogen');
    return tt('face_default', 'Die Form spielt gut mit deinen Proportionen zusammen');
  }

  function reasonFor(entry, answers) {
    var p = entry.product, w = entry.why;
    var styleLabel = answers.style;
    var faceOk = w.face >= 2 && answers.face;

    if (w.style && w.size) {
      return fmt(tt('r_style_size', 'Passt zu deinem {style}-Look und {size}.'), { style: styleLabel, size: SIZE_PHRASE[p.size] });
    }
    if (w.style && faceOk) {
      return fmt(tt('r_style_face', '{face} und passt zu deinem {style}-Look.'), { face: facePhrase(p, answers.face), style: styleLabel });
    }
    if (w.style) {
      return fmt(tt('r_style', 'Eine starke Wahl, wenn du einen {style}-Look suchst.'), { style: styleLabel });
    }
    if (w.size && faceOk) {
      return fmt(tt('r_size_face', '{face} — und die Brille {size}.'), { face: facePhrase(p, answers.face), size: SIZE_PHRASE[p.size] });
    }
    if (w.size) {
      return fmt(tt('r_size', 'Die Brille {size}.'), { size: SIZE_PHRASE[p.size] });
    }
    if (faceOk) {
      return facePhrase(p, answers.face) + '.';
    }
    return tt('r_default', 'Ein vielseitiges Modell, das sich leicht kombinieren lässt.');
  }

  /* ---------- Finder ---------- */

  function initFinder(root) {
    var dataEl = document.getElementById('sesto-fit-data');
    var products = [];
    try { products = JSON.parse(dataEl.textContent) || []; }
    catch (e) { root.setAttribute('data-sfit-error', 'data'); return; }
    if (!products.length) { root.setAttribute('data-sfit-error', 'empty'); return; }

    var screens = root.querySelector('[data-sfit-screens]');
    var barFill = root.querySelector('[data-sfit-bar]');
    var stepEl = root.querySelector('[data-sfit-step]');
    var backBtn = root.querySelector('[data-sfit-back]');
    var head = root.querySelector('[data-sfit-progress]');
    var resultsList = root.querySelector('[data-sfit-results]');
    var moreList = root.querySelector('[data-sfit-results-more]');
    var moreWrap = root.querySelector('[data-sfit-more-wrap]');
    var sizeNote = root.querySelector('[data-sfit-size-note]');
    var hero = root.querySelector('[data-sfit-hero]');

    var entry = readEntry();

    var answers = { gender: null, face: null, size: null, style: null };
    var history = [];

    /* Die Gender-Frage steht nur im Ablauf, wenn sie etwas bewirkt. */
    var useGender = genderIsMeaningful(products);
    var steps = useGender
      ? ['q-gender', 'q-face', 'q-size', 'q-style']
      : ['q-face', 'q-size', 'q-style'];
    var START = steps[0];
    var current = START;

    /* Der Mini-Guide ist kein eigener Schritt, sondern eine Vertiefung von
       Frage "Gesichtsform" — er zeigt deshalb deren Nummer. Nicht fest 1:
       mit Gender davor ist Gesichtsform Schritt 2. */
    function stepIndex(id) {
      var i = steps.indexOf(id);
      if (i !== -1) return i + 1;
      if (id === 'help-face') return steps.indexOf('q-face') + 1;
      return 0;
    }

    function show(id, opts) {
      opts = opts || {};
      if (!opts.back && current !== id) history.push(current);
      current = id;

      Array.prototype.forEach.call(screens.children, function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-sfit-screen') === id);
      });

      var idx = stepIndex(id);
      head.style.visibility = idx > 0 ? 'visible' : 'hidden';
      if (idx > 0) {
        stepEl.textContent = idx + ' / ' + steps.length;
        barFill.style.width = (idx / steps.length) * 100 + '%';
      }
      backBtn.hidden = history.length === 0 || id === 'results';

      /* Der Hero traegt die Markenaussage waehrend der Fragen. Auf dem
         Ergebnisscreen wuerde er mit dessen eigener Ueberschrift
         konkurrieren, deshalb dort ausgeblendet. */
      if (hero) hero.hidden = (id === 'results');

      var h = screens.querySelector('[data-sfit-screen="' + id + '"] [data-sfit-focus]');
      if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    }

    function goBack() {
      if (!history.length) return;
      show(history.pop(), { back: true });
    }

    function answer(key, value, eventName) {
      answers[key] = value;
      track(eventName, { value: value === null ? 'unknown' : value });
    }

    function optionButton(cfg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sfit-opt';
      b.innerHTML =
        (cfg.icon ? '<span class="sfit-opt__icon">' + cfg.icon + '</span>' : '') +
        '<span class="sfit-opt__body">' +
          '<span class="sfit-opt__label">' + esc(cfg.label) + '</span>' +
          (cfg.desc ? '<span class="sfit-opt__desc">' + esc(cfg.desc) + '</span>' : '') +
        '</span>';
      b.addEventListener('click', cfg.onClick);
      return b;
    }

    function fill(container, list) {
      container.innerHTML = '';
      list.forEach(function (cfg) { container.appendChild(optionButton(cfg)); });
    }

    function svgFace(shape) {
      var d = {
        Round:   'M30 6c13 0 21 11 21 26 0 17-9 30-21 30S9 49 9 32C9 17 17 6 30 6z',
        Oval:    'M30 5c11 0 18 11 18 27 0 19-8 32-18 32s-18-13-18-32C12 16 19 5 30 5z',
        Square:  'M13 10h34v30c0 13-7 22-17 22s-17-9-17-22V10z',
        Heart:   'M11 16c0-6 8-10 19-10s19 4 19 10c0 16-8 30-19 46C19 46 11 32 11 16z',
        Diamond: 'M30 4l20 28-20 30L10 32 30 4z'
      }[shape];
      return '<svg viewBox="0 0 60 72" fill="none" stroke="currentColor" stroke-width="1.6" ' +
             'stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
    }

    /* Frage — Ausrichtung. Wird nur befuellt und angezeigt, wenn sie im
       Ablauf steht; andernfalls bleibt der Screen leer und unerreichbar.
       Der Screen tragt im Markup is-active, damit vor dem ersten
       JS-Frame keine andere Frage aufblitzt. Laeuft der Finder ohne
       Gender, korrigiert show(START) das im selben Frame. */
    var genderBox = root.querySelector('[data-sfit-gender-options]');
    if (useGender && genderBox) {
      fill(genderBox, GENDER_ANSWERS.map(function (a) {
        return {
          label: a.label, desc: a.desc,
          onClick: function () {
            answer('gender', a.value, 'fit_gender_selected');
            show('q-face');
          }
        };
      }));
    }

    /* Frage — Gesichtsform */
    fill(root.querySelector('[data-sfit-face-options]'), FACES.map(function (s) {
      return {
        icon: svgFace(s), label: FACE_COPY[s].label, desc: FACE_COPY[s].desc,
        onClick: function () { answer('face', s, 'fit_face_shape_selected'); show('q-size'); }
      };
    }).concat([{
      label: tt('dont_know', 'WEISS ICH NICHT'), desc: tt('face_show_d', 'Zeig mir kurz die Formen.'),
      onClick: function () { show('help-face'); }
    }]));

    /* Mini-Guide */
    var guide = root.querySelector('[data-sfit-face-guide]');
    guide.innerHTML = '';
    FACES.forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sfit-face';
      b.innerHTML = svgFace(s) +
        '<span class="sfit-face__label">' + esc(FACE_COPY[s].label) + '</span>' +
        '<span class="sfit-face__desc">' + esc(FACE_COPY[s].desc) + '</span>';
      b.addEventListener('click', function () {
        answer('face', s, 'fit_face_shape_selected');
        show('q-size');
      });
      guide.appendChild(b);
    });

    /* Frage — Groesse */
    fill(root.querySelector('[data-sfit-size-options]'), SIZE_ANSWERS.map(function (a) {
      return {
        label: a.label, desc: a.desc,
        onClick: function () { answer('size', a.value, 'fit_size_selected'); show('q-style'); }
      };
    }));

    /* Frage — Look */
    fill(root.querySelector('[data-sfit-style-options]'), STYLE_ANSWERS.map(function (a) {
      return {
        label: a.label, desc: a.desc,
        onClick: function () { answer('style', a.value, 'fit_style_selected'); finish(); }
      };
    }));

    function renderCard(entryItem, position, group) {
      var p = entryItem.product;
      var meta = [p.shape, p.size].filter(Boolean).join(' · ');
      var el = document.createElement('article');
      el.className = 'sfit-card' + (group === 'more' ? ' sfit-card--more' : '');
      el.setAttribute('data-sfit-position', String(position));
      el.innerHTML =
        '<a class="sfit-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" decoding="async" width="240" height="240">' : '') +
        '</a>' +
        '<div class="sfit-card__body">' +
          '<h3 class="sfit-card__name">' + esc(p.title) + '</h3>' +
          (meta ? '<p class="sfit-card__meta">' + esc(meta) + '</p>' : '') +
          (p.price ? '<p class="sfit-card__price">' + esc(p.price) + '</p>' : '') +
          '<dl class="sfit-card__why">' +
            '<dt>' + esc(tt('why', 'Warum wir sie ausgewählt haben')) + '</dt>' +
            '<dd>' + esc(reasonFor(entryItem, answers)) + '</dd>' +
          '</dl>' +
          (p.available
            ? '<a class="sfit-card__cta" href="' + esc(p.url) + '" data-sfit-product>' + esc(fmt(tt('view', '{title} ansehen'), { title: p.title })) + '</a>'
            : '<span class="sfit-card__soldout">' + esc(tt('unavailable', 'Derzeit nicht verfügbar')) + '</span>') +
        '</div>';

      var cta = el.querySelector('[data-sfit-product]');
      if (cta) {
        cta.addEventListener('click', function () {
          track('fit_product_click', {
            item_name: p.title,
            item_id: String(p.id),
            result_position: position,
            result_group: group,
            entry_source: entry.source,
            entry_collection: entry.collection,
            entry_product: entry.product || 'none'
          });
        });
      }
      return el;
    }

    function finish() {
      var pool = poolFor(products, answers);
      var picks = recommend(products, answers);
      var top = picks.slice(0, TOP_PICKS);
      var more = picks.slice(TOP_PICKS);

      resultsList.innerHTML = '';
      top.forEach(function (e, i) { resultsList.appendChild(renderCard(e, i + 1, 'top')); });

      if (moreList) {
        moreList.innerHTML = '';
        more.forEach(function (e, i) {
          moreList.appendChild(renderCard(e, TOP_PICKS + i + 1, 'more'));
        });
      }
      /* Weniger als vier bewertbare Modelle: dann gibt es schlicht keinen
         zweiten Block, statt eine leere Ueberschrift stehen zu lassen. */
      if (moreWrap) moreWrap.hidden = more.length === 0;

      /* Ehrlich bleiben, wenn es die gewuenschte Breite gar nicht gibt:
         dann keine "passt perfekt"-Aussage, sondern ein klarer Hinweis. */
      /* Gegen die ZULAESSIGE Menge pruefen, nicht gegen den Gesamtkatalog:
         sonst behauptet der Hinweis eine Breite, die es im gewaehlten
         Zweig gar nicht gibt. */
      var hasExact = answers.size && pool.some(function (p) { return p.size === answers.size; });
      if (answers.size && !hasExact) {
        sizeNote.textContent = tt('size_note', 'In dieser Breite haben wir aktuell kein eigenes Modell — das sind die nächstbesten aus unserer Kollektion.');
        sizeNote.hidden = false;
      } else {
        sizeNote.hidden = true;
      }

      track('fit_finder_complete', {
        gender: answers.gender || 'any',
        pool_size: pool.length,
        face_shape: answers.face || 'unknown',
        size: answers.size || 'unknown',
        style: answers.style || 'any',
        results: picks.length,
        results_top: top.length,
        results_more: more.length,
        entry_source: entry.source,
        entry_collection: entry.collection,
        entry_product: entry.product || 'none'
      });

      show('results');
    }

    root.querySelectorAll('[data-sfit-restart]').forEach(function (b) {
      b.addEventListener('click', function () {
        answers = { gender: null, face: null, size: null, style: null };
        history = [];
        track('fit_finder_restart', { entry_source: entry.source, entry_collection: entry.collection });
        show(START);
      });
    });

    root.querySelectorAll('[data-sfit-skip-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        answer('face', null, 'fit_face_shape_selected');
        show('q-size');
      });
    });

    root.querySelectorAll('[data-sfit-shop-all]').forEach(function (a) {
      a.addEventListener('click', function () {
        track('fit_shop_all_click', {
          entry_source: entry.source,
          entry_collection: entry.collection
        });
      });
    });

    backBtn.addEventListener('click', goBack);

    /* Direkt bei Frage 1 starten. { back: true } verhindert, dass ein
       nicht existierender Vorgaenger-Screen in die History wandert und der
       Zurueck-Button schon auf Frage 1 erscheint. */
    show(START, { back: true });
    track('fit_finder_start', {
      gender_step: useGender,
      steps: steps.length,
      entry_source: entry.source,
      entry_collection: entry.collection,
      entry_product: entry.product || 'none'
    });

    /* Fuer QA im Browser:
       window.SESTO_FIT.simulate('Round','Narrow','Bold')          — ohne Gender
       window.SESTO_FIT.simulate('Round','Narrow','Bold','Women')  — Damen-Zweig */
    window.SESTO_FIT = {
      products: products,
      entry: entry,
      maxResults: MAX_RESULTS,
      topPicks: TOP_PICKS,
      genderStep: useGender,
      steps: steps.slice(),
      poolSize: function (gender) {
        return poolFor(products, { gender: gender || null }).length;
      },
      simulate: function (face, size, style, gender) {
        var a = {
          gender: gender || null,
          face: face || null,
          size: size || null,
          style: style || null
        };
        return recommend(products, a).map(function (e, i) {
          return {
            position: i + 1,
            title: e.product.title,
            shape: e.product.shape,
            size: e.product.size,
            gender: e.product.gender,
            score: e.score,
            reason: reasonFor(e, a)
          };
        });
      }
    };
  }

  function boot() {
    document.querySelectorAll('[data-sesto-fit-finder]').forEach(function (root) {
      if (root.getAttribute('data-sfit-ready') === '1') return;
      root.setAttribute('data-sfit-ready', '1');
      try { initFinder(root); }
      catch (e) {
        root.setAttribute('data-sfit-error', 'init');
        if (window.console) console.warn('[SESTO FIT]', e);
      }
    });
    document.querySelectorAll('[data-sfit-guide-open]').forEach(function (a) {
      if (a.getAttribute('data-sfit-bound') === '1') return;
      a.setAttribute('data-sfit-bound', '1');
      a.addEventListener('click', function () { track('fit_guide_open'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
